import axios from "axios";
const url = require('url');

export default class BaseQuery {
    static getOrigin() {
        const parsedUrl = new url.parse(window.location.href);
        let port = parsedUrl.hostname === 'localhost' ? '18888' : parsedUrl.port;
        let origin = parsedUrl.protocol+'//'+parsedUrl.hostname+ (port ? ':'+port : '');
        // console.log(origin);
        return origin;
    }

    static queryGet(params, successCb, errCb) {

        axios.get(BaseQuery.getOrigin()+`/index.php`, {params})
            .then(res => {

                let data = res.hasOwnProperty('data') && typeof res.data === 'string'
                    ? JSON.parse(res.data)
                    : res.data;

                if (data.result === "OK")
                {
                    successCb(data);
                    return;
                }

                if (data.result === "FAIL")
                {
                    errCb(data.error);
                    return;
                }

                errCb('No data');

            }).catch((error) => {
                errCb(error);
                console.log(error);
        });
    }

    static queryPost(params, successCb, errCb) {
        axios.post(BaseQuery.getOrigin()+`/index.php`, {params})
            .then(res => {

                let data = res.hasOwnProperty('data') && typeof res.data === 'string'
                    ? JSON.parse(res.data)
                    : res.data;

                if (data.result === "OK")
                {
                    successCb(data);
                    return;
                }

                errCb('No data');

            }).catch((error) => {
                errCb(error);
                console.log(error);
        });
    }
}
